import React from "react";
import { useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";

export default function PaymentResultPage() {
    const [searchParams] = useSearchParams();
    const status = searchParams.get("status");

    // You can also capture the registrationId if needed for API calls
    // const registrationId = searchParams.get("registrationId");

    const handleHomeRedirect = () => {
        // Reads from environment variables (Adjust prefix based on CRA vs Vite)
        // Fallback to root "/" if missing.
        const homeUrl =  "/";
        window.location.href = homeUrl;
    };

    // Handle successful payment
    if (status === "success") {
        return (
            <main className="min-h-screen w-full flex items-center justify-center bg-slate-50 dark:bg-slate-950 p-4 sm:p-6">
                <div className="w-full max-w-md p-8 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl shadow-xl flex flex-col items-center text-center transition-all">
                    <div className="mb-6 rounded-full bg-emerald-50 dark:bg-emerald-900/30 p-3">
                        <CheckCircle2 className="w-16 h-16 text-emerald-500 dark:text-emerald-400" />
                    </div>

                    <h1 className="text-2xl font-bold text-slate-900 dark:text-white mb-3">
                        Payment Successful
                    </h1>

                    <p className="text-slate-600 dark:text-slate-400 mb-8 leading-relaxed">
                        Your payment has been completed successfully. <br className="hidden sm:block" />
                        <strong>Please check your registered email for the verification link to activate your account.</strong>
                    </p>
                </div>
            </main>
        );
    }

    // Handle failed or missing status (Fallback UI)
    return (
        <main className="min-h-screen w-full flex items-center justify-center bg-slate-50 dark:bg-slate-950 p-4 sm:p-6">
            <div className="w-full max-w-md p-8 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl shadow-xl flex flex-col items-center text-center transition-all">
                <div className="mb-6 rounded-full bg-rose-50 dark:bg-rose-900/30 p-3">
                    <XCircle className="w-16 h-16 text-rose-500 dark:text-rose-400" />
                </div>

                <h1 className="text-2xl font-bold text-slate-900 dark:text-white mb-3">
                    Payment Verification Failed
                </h1>

                <p className="text-slate-600 dark:text-slate-400 mb-8 leading-relaxed">
                    We couldn't verify your payment status. If your account was charged, please contact support with your registration details.
                </p>

            <button
                    onClick={handleHomeRedirect}
                    className="w-full h-11 px-6 rounded-lg bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 dark:hover:bg-slate-700 text-slate-900 dark:text-white font-medium transition-colors outline-none"
                >
                    Return to Home
                </button>
            </div>
        </main>
    );
}